import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardBody,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
  Pagination,
  PaginationItem,
  PaginationLink,
} from "reactstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import pluscircle from "../homework/assets/images/plus circle_.png";
import grp713 from "../homework/assets/images/Group 713.png";
import delete1 from "../homework/assets/images/delete.png";
import axiosInstance from "../../axiosInterceptor";
import Styles from "../homework/assets/Form.module.css";

const Review = () => {
  const [reviews, setReviews] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const perPage = 10;
  const navigator = useNavigate();

  const fetchCourseReviews = async (page = 1) => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `admin/courseReview/getReviewAll?pageNo=${page}&perPage=${perPage}`,
      );

      if (response?.data?.isSuccess) {
        const reviewData = response.data.data || [];
        setReviews(reviewData);
        setTotalPages(response.data.totalPages || 0);
        setCurrentPage(response.data.currentPageNo || page);
      } else {
        setReviews([]);
        setTotalPages(0);
        toast.error(response?.data?.message || "Failed to fetch reviews");
      }
    } catch (error) {
      console.error("Error fetching reviews:", error);
      setReviews([]);
      setTotalPages(0);
      toast.error("Something went wrong. Please try again!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCourseReviews();
  }, []);

  const handlePageClick = (page) => {
    if (page >= 1 && page <= totalPages) {
      fetchCourseReviews(page);
    }
  };

  const handleDelete = (id) => {
    setDeleteItemId(id);
    setModalOpen(true);
  };

  const confirmDelete = async () => {
    try {
      const response = await axiosInstance.delete(
        `admin/courseReview/deleteReview/${deleteItemId}`,
      );
      if (response?.data?.isSuccess) {
        toast.success(response.data.message);
        fetchCourseReviews(currentPage);
      } else {
        toast.error(response.data.message || "Delete operation failed");
      }
    } catch (error) {
      console.error("Error deleting review:", error);
      toast.error("Something went wrong. Please try again!");
    } finally {
      setDeleteItemId(null);
      setModalOpen(false);
    }
  };

  return (
    <>
      <div>
        <div className="my-2">
          <div className="row mb-2">
            <div className="d-flex justify-content-between">
              <div>
                <h4 className="page-title">Reviews</h4>
              </div>
              <div>
                <Link to={`/add-reviews`}>
                  <Button className="action-button add-from-new">
                    <img
                      src={pluscircle}
                      alt="plus"
                      width={20}
                      className="ADD_code"
                    />
                    <span> Add </span>
                  </Button>
                </Link>
              </div>
            </div>
          </div>

          <Card>
            <CardBody>
              {loading ? (
                <div className="text-center mt-4">
                  <p>Loading...</p>
                </div>
              ) : reviews?.length > 0 ? (
                <Table
                  bordered
                  striped
                  responsive
                  className="mt-4 text-center"
                  style={{ fontSize: "0.8rem" }}
                >
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Reviewer's Name</th>
                      <th>Rating</th>
                      <th>Date</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {reviews.map((review, index) => {
                      const serialNumber =
                        (currentPage - 1) * perPage + index + 1;
                      return (
                        <tr key={review?._id || index}>
                          <th scope="row">{serialNumber}</th>
                          <td>{review?.name || "N/A"}</td>
                          <td>{review?.ratings || "N/A"}</td>
                          <td>{review?.date || "N/A"}</td>
                          <td className="d-flex justify-content-center">
                            <div className={Styles.edit_code}>
                              <Button
                                className={Styles.edit_code}
                                onClick={() => {
                                  navigator(`/add-reviews`, {
                                    state: review,
                                  });
                                }}
                              >
                                <img src={grp713} alt="edit" width={20} />
                                Edit
                              </Button>
                            </div>
                            <div
                              className={`${Styles.delete_button_code} me-2 mx-2`}
                            >
                              <Button
                                className={Styles.delete_button_code}
                                onClick={() => handleDelete(review._id)}
                              >
                                <img
                                  src={delete1}
                                  alt="delete"
                                  className={Styles.delete_icon}
                                />
                                Delete
                              </Button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              ) : (
                <div className="text-center mt-4">
                  <p>No reviews found.</p>
                </div>
              )}
              {reviews.length > 0 && (
                <div className="float-end mt-3">
                  <Pagination>
                    <PaginationItem disabled={currentPage === 1}>
                      <PaginationLink
                        previous
                        onClick={() => handlePageClick(currentPage - 1)}
                      />
                    </PaginationItem>
                    {Array.from(
                      { length: totalPages },
                      (_, index) => index + 1,
                    ).map((page) => {
                      if (
                        page === 1 ||
                        page === totalPages ||
                        Math.abs(currentPage - page) <= 1
                      ) {
                        return (
                          <PaginationItem
                            key={page}
                            active={page === currentPage}
                          >
                            <PaginationLink
                              onClick={() => handlePageClick(page)}
                            >
                              {page}
                            </PaginationLink>
                          </PaginationItem>
                        );
                      }
                      if (
                        (page === currentPage - 2 ||
                          page === currentPage + 2) &&
                        totalPages > 5
                      ) {
                        return (
                          <PaginationItem key={`ellipsis-${page}`} disabled>
                            <PaginationLink>...</PaginationLink>
                          </PaginationItem>
                        );
                      }
                      return null;
                    })}
                    <PaginationItem disabled={currentPage === totalPages}>
                      <PaginationLink
                        next
                        onClick={() => handlePageClick(currentPage + 1)}
                      />
                    </PaginationItem>
                  </Pagination>
                </div>
              )}
            </CardBody>
          </Card>
        </div>
      </div>

      <Modal
        isOpen={modalOpen}
        toggle={() => setModalOpen(!modalOpen)}
        style={{ top: "33%" }}
      >
        <ModalHeader toggle={() => setModalOpen(!modalOpen)}>
          Confirm Delete
        </ModalHeader>
        <ModalBody>Are you sure you want to delete this review?</ModalBody>
        <ModalFooter>
          <div className={Styles.button_color}>
            <Button type="cancel" onClick={() => setModalOpen(!modalOpen)}>
              No
            </Button>
          </div>
          <div className={`${Styles.cancel_button} me-4`}>
            <Button
              type="cancel"
              className={Styles.cancel_button}
              onClick={confirmDelete}
            >
              Yes
            </Button>
          </div>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default Review;
